import CompraProdutoCacheModel from "./CompraProdutoCacheModel";
import C5PagamentoModel from "./C5PagamentoModel";
import AgendamentoRetiradaModel from "./AgendamentoRetiradaModel";
import AppState from "./AppState";
import CarrinhoModel from "./CarrinhoModel";
import CarrinhoItemModel from "./CarrinhoItemModel";
import { CieloCustomer, CieloPagamentoCache } from "./CieloPagamentoModel";
import UsuarioModel from "./UsuarioModel";
import UsuarioEnderecoModel from "./UsuarioEnderecoModel";

export default class CompraCacheModel {
  public compraId: string = "";
  public lojaId: string = "";
  public textoAlternativo: string = "";
  public descricaoAgendamento: string = "";
  public produtos: CompraProdutoCacheModel[] = [];
  public criadoEm: Date = new Date();
  public excluidoEm?: Date = new Date();

  public static toModel(item: any): CompraCacheModel {
    return {
      compraId: item.id,
      textoAlternativo: item.alternativeOption,
      descricaoAgendamento: item.scheduleDescription,
      mensagemEntrega: item.deliveryMessage,
      lojaId: item.storeId,
      produtos:
        (item.products && item.products.length) > 0
          ? item.products.map((i: any) => CompraProdutoCacheModel.toModel(i))
          : [],
      criadoEm: new Date(Date.parse(item.createdAt)),
      excluidoEm: new Date(Date.parse(item.deletedAt)),
    } as CompraCacheModel;
  }

  public static toModelFromC5(
    item: C5PagamentoModel,
    id: string,
  ): CompraCacheModel | null {
    const objRetirada: AgendamentoRetiradaModel | null = AppState.getAgendamentoRetirada();
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const produtos: CompraProdutoCacheModel[] = carrinho.carrinhoItens.map(
      (ci: CarrinhoItemModel) => {
        return {
          produtoId: ci.produto.produtoId,
          notas: ci.notas,
          unidade: ci.produto.unidade,
          precoUnitario: ci.produto.precoOriginal,
          precoUnitarioDesconto: ci.produto.precoDesconto,
          fatorMultiplicacao: ci.produto.fatorMultiplicacao,
          quantidade: ci.quantidade,
          nome: ci.produto.nome,
        } as CompraProdutoCacheModel;
      }
    );

    if (objRetirada) {
      return ({
        compraId: id,
        textoAlternativo: item.Notes,
        descricaoAgendamento: objRetirada.titulo,
        lojaId: item.SalesChannelID,
        produtos,
        criadoEm: new Date(),
        excluidoEm: null,
      } as unknown) as CompraCacheModel;
    }
    return null;
  }

  public static toApi(item: CompraCacheModel, user: UsuarioModel, address: UsuarioEnderecoModel): any {
    const objAddress = {
      Street: address.endereco,
      'Number': address.numero,
      Complement: address.complemento,
      ZipCode: address.cep,
      City: address.cidadeEstado.indexOf('/') > -1 ? address.cidadeEstado.split('/')[0].trim() : address.cidadeEstado.trim(),
      State: address.cidadeEstado.indexOf('/') > -1 ? address.cidadeEstado.split('/')[1].trim() : address.cidadeEstado.trim(),
      Country: 'Brasil'
    };
    return {
      Id: item.compraId,
      AlternativeOption: item.textoAlternativo,
      ScheduleDescription: item.descricaoAgendamento,
      Products: item.produtos.map(CompraProdutoCacheModel.toApi),
      CreatedAt: item.criadoEm,
      DeletedAt: item.excluidoEm,
      StoreId: item.lojaId,
      Customer: {
        Name: user.nome,
        Identity: user.documento,
        IdentityType: 'CPF',
        Email: user.email,
        Birthdate: user.nascimento,
        Address: objAddress,
        DeliveryAddress: objAddress
      }
    };
  }

  public static toApiCielo(item: CompraCacheModel, pagamentoCielo: any, totalCompra: number, cvv: string, customer: CieloCustomer): any {
    return {
      Id: item.compraId,
      AlternativeOption: item.textoAlternativo,
      ScheduleDescription: item.descricaoAgendamento,
      Products: item.produtos.map(CompraProdutoCacheModel.toApi),
      CreatedAt: item.criadoEm,
      DeletedAt: item.excluidoEm,
      StoreId: item.lojaId,
      Payment: {
        AuthorizedAmount: +totalCompra,
        AuthorizedAt: new Date(),
        CardToken: pagamentoCielo.data.payment.creditCard.cardToken,
        Code: cvv,
        PaymentId: pagamentoCielo.data.payment.paymentId,
        CapturedAmount: 0,
        CanceledAt: null,
        CanceledPayment: null,
        CapturedAt: null,
        Nsu: pagamentoCielo.data.payment.proofOfSale,
        Tid: pagamentoCielo.data.payment.tid,
        AuthorizationCode: pagamentoCielo.data.payment.authorizationCode,
        CardBin: pagamentoCielo.cardBin,
        Last4: pagamentoCielo.last4,
        CodigoBandeira: pagamentoCielo.codigoBandeira,
        HolderName: pagamentoCielo.holderName,
        Expiration: pagamentoCielo.expiration,
      } as CieloPagamentoCache,
      Customer: customer,
    };
  }
}
